import React, {useMemo, useState} from "react";
import TablePage from "../../pages/tablePage/TablePage";
import MailTitleEditModal from "../country/MailTitleEditModal";
import {useCountryData} from "../country/useCountryData";
import ErrorPage from "../../shared/components/ErrorPage";
import IsLoading from "../../shared/components/IsLoading";
import {useMailTitle} from "../country/useMailTitle";

const NewMailTitle = () => {
    const [rowData, setRowData] = useState({});
    const { data: countryData, isLoading, error } = useCountryData();
    const { data: mailTitleData, isLoading: isMailTitleLoading,  error: isMailTitleError} = useMailTitle();

    const languageList = useMemo(() => {
        if (!countryData) {
            return [];
        }

        const uniqueLangCode = [...new Set(countryData.map((row) => row.langCode))];
        return uniqueLangCode.map((lang) => ({
            title: lang,
            dataIndex: lang,
            key: lang,
        }));
    }, [countryData]);

    const localData = useMemo(() => {
        if (!mailTitleData) {
            return [];
        }

        return mailTitleData.map((row) => {
            const titleData = {};
            row.title.forEach((title) => {
                titleData[title.langCode] = title.text;
            });

            return {
                index: row.index,
                ...titleData,
            };
        });
    }, [mailTitleData]);

    if (isLoading || isMailTitleLoading) return <IsLoading />;
    const firstError = error || isMailTitleError;
    if (firstError) return <ErrorPage error={firstError} />;

    const columns = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            search: true,
        },
        ... languageList,
    ];

    const props = {
        columns,
        rowData,
        setRowData,
        modal: MailTitleEditModal,
        buttonText: '타이틀 추가',
        localData,
    }

    return (
        <TablePage {...props}/>
    )
}

export default NewMailTitle;